module.exports = __webpack_public_path__ + "img/premiation.24e5c08a.svg";